import type { TextLevel } from "../../../../../../mads/Text/TextLevel";

import { Heading } from "../../../../../../mads";

import { colors } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { StyleSheet, type TextProps } from "react-native";

export interface JobTitleProps {
  jobTitle: string;
  level?: TextLevel;
  compact?: boolean;
  ellipsizeMode?: TextProps["ellipsizeMode"];
  numberOfLines?: number;
  testID?: string;
  useBrandedDesktopSpacing?: boolean;
}

/**
 * This is the simplified jobtitle without company logo
 */
export function JobTitle(props: JobTitleProps) {
  return (
    <Heading
      ellipsizeMode={props.ellipsizeMode}
      level={props.level}
      numberOfLines={props.numberOfLines}
      sx={StyleSheet.flatten([
        styles.default,
        props.useBrandedDesktopSpacing && styles.brandedDesktop,
        props.compact && styles.compact,
      ])}
      testID={props.testID ?? "vj-job-title"}
    >
      {props.jobTitle}
    </Heading>
  );
}

const styles = StyleSheet.create({
  default: {
    color: colors.foregroundStrong,
    marginBottom: 8,
    marginTop: 0,
  },
  compact: {
    flexShrink: 1,
    marginBottom: 0,
    minWidth: 0,
    paddingVertical: 4,
  },
  brandedDesktop: {
    marginBottom: 4,
  },
});
